import { useTranslation } from '../../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../../types/constants';

interface OrderSectionLayoutProps {
  sidebar?: React.ReactNode;
  subtitle?: string;
  children: React.ReactNode;
}

export const OrderSectionLayout = ({ sidebar, subtitle, children }: OrderSectionLayoutProps) => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-4 w-full">
      <div className="flex flex-col lg:flex-row justify-between gap-4 lg:gap-[134px] w-full items-start">
        <div className="flex flex-col gap-4 w-[301px]">
          <div className="flex flex-col gap-1">
            <h2 className="font-bold text-heading-125 leading-heading text-black-950">
              {t(TranslationKeyEnum.Orders)}
            </h2>
            <p className="font-bold text-heading-125 leading-heading text-black-600">
              {subtitle ?? t(TranslationKeyEnum.PlanYourWeeklyDelivery)}
            </p>
          </div>
          {sidebar}
        </div>
        <div className="flex flex-col gap-2 w-full">{children}</div>
      </div>
    </section>
  );
};
